import { Card, Divider, Typography, useTheme } from "@mui/material";
import useLocales from "src/hooks/useLocales";

import AuthenticationRow from "./AuthenticationRow";

// ----------------------------------------------------------------------

export const SecurityCard = () => {
	const theme = useTheme();
	const { translate } = useLocales();

	return (
		<Card sx={{ maxWidth: 800, p: 3, mt: 4 }}>
			<Typography variant='h6'>{translate("profile.2fa")}</Typography>
			<Typography variant='body2' color='text.secondary'>
				{translate("profile.2fa_description_1")}
			</Typography>
			<Divider sx={{ my: 3, borderColor: theme.palette.grey[200] }} />
			<AuthenticationRow />
		</Card>
	);
};

export default SecurityCard;
